export const DATA_HOOKS = {
  Title: 'title',
  Subtitle: 'subtitle',
  Badge: 'badge',
  PrimaryAction: 'primary-action',
  SecondaryAction: 'secondary-action',
  HoverContent: 'hover-content',
  HoverComponent: 'hover-component',
  SettingsMenu: 'settings-menu',
  footerSettingsMenu: 'footer-settings-menu',
  bottomActions: 'bottom-actions',
  BottomPrimaryAction: 'bottom-primary-action',
  BottomSecondaryAction: 'bottom-secondary-action',
  Container: 'container',
  Card: 'card',
  footer: 'footer',
  dragHandle: 'drag-handle',
  footerImage: 'footer-image',
  suffix: 'suffix',
  customFooter: 'custom-footer',
} as const;

export const SIZES = {
  small: 'small',
  medium: 'medium',
} as const;
